import { whatsappNumber, whatsappMessage, displayPhone } from "../data";

export default function Hero() {
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <section id="hero" className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/4e71b801-c90a-47f7-85ee-3bc83ce8f4f0/5cfd0510-b0c9-42b0-917e-4515eb6ec608_ChatGPT-Image-4-Haz-2026-00_28_44.png?v=26c45c9806b8bd29f3c9bd04176e0d1f"
          alt="Karasu Plaj Cadde Tekel dükkanı ön cephesi"
          className="w-full h-full object-fill"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center pt-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-full mb-6 md:mb-8">
          <div className="w-2 h-2 bg-accent-500 rounded-full animate-pulse"></div>
          <span className="text-xs md:text-sm text-background-50 font-medium">
            WhatsApp ile Anında İletişim
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight max-w-4xl">
          Karasu'da Evlere
          <br />
          <span className="text-primary-300">Kurye Servisi</span>
        </h1>

        <p className="mt-4 md:mt-6 text-sm md:text-lg text-background-50/80 max-w-xl leading-relaxed">
          Resmi Bayi Güvencesi: Efes ve Tuborg bayisi olarak, en sevdiğiniz
          ürünleri taze ve ideal soğuklukta sunuyoruz.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 mt-8 md:mt-10">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 px-8 py-4 bg-accent-500 hover:bg-accent-600 text-background-50 rounded-full font-semibold text-sm md:text-base transition-all hover:scale-105 cursor-pointer whitespace-nowrap group"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            WhatsApp'tan Sipariş Ver
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </a>
          <a
            href={`tel:+${whatsappNumber}`}
            className="flex items-center gap-2 px-8 py-4 border border-background-50/30 text-background-50 hover:bg-background-50/10 rounded-full font-semibold text-sm md:text-base transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            {displayPhone}
          </a>
        </div>

        <div className="mt-16 md:mt-20 flex items-center gap-8 md:gap-12">
          {[
            { icon: "ri-time-line", text: "Her Gün 7/24 Servis" },
            { icon: "ri-map-pin-line", text: "Karasu" },
            { icon: "ri-truck-line", text: "Hızlı Teslimat" },
          ].map((item, i) => (
            <div key={i} className="flex items-center gap-2 text-background-50/70">
              <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center">
                <i className={`${item.icon} text-sm md:text-base`}></i>
              </div>
              <span className="text-xs md:text-sm whitespace-nowrap">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}